import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero-section">
      <div className="hero-container">
        <div className="hero-content">
          <h1 className="hero-title">
            Vaše putovanje u majčinstvo
          </h1>
          <p className="hero-description">
            Osnaživanje budućih i novopečenih majki sa iskrenim uputstvima, 
            praktičnim savetima i zajednicom podrške za svaki korak vašeg 
            prelepog putovanja.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Hero; 